import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import React from 'react';
import Barcode from 'react-barcode';
import { encodedBarcodeUrl } from 'src/utils/barcodeEncoding';
import { BUREAU_BARCODE_FORMAT } from 'src/utils/constants';

const renderCodeOutput = (url, isBarcode, isRicoh) => {
  if (!url) {
    return <svg width='250' height='250' />;
  }

  return (
    <a href={url}>
      {isBarcode ? (
        <Barcode width={1.5} value={encodedBarcodeUrl(url)} />
      ) : (
        <QRCode size={isRicoh ? 150 : 250} value={url} renderAs='svg' />
      )}
    </a>
  );
};

const BarcodeQrCodeOutput = ({ url, scanningMode, className, isRicoh }) => {
  const isBarcode = scanningMode === BUREAU_BARCODE_FORMAT.BARCODE;

  return (
    <div
      className={`${className || ''} ${isRicoh ? null : isBarcode ? BUREAU_BARCODE_FORMAT.BARCODE : BUREAU_BARCODE_FORMAT.QR}`}
    >
      {renderCodeOutput(url, isBarcode, isRicoh)}
    </div>
  );
};

BarcodeQrCodeOutput.defaultProps = {
  className: '',
  isRicoh: false,
};

BarcodeQrCodeOutput.propTypes = {
  url: PropTypes.string.isRequired,
  scanningMode: PropTypes.string.isRequired,
  className: PropTypes.string,
  isRicoh: PropTypes.bool,
};

export default BarcodeQrCodeOutput;
